import { Button, Stack, Theme, Typography } from '@mui/material'
import { IChartData, IRevenueExpense } from '../../definitions/DataAnalytics'
import { QueryStatus } from '../hooks/useQuery'
import LineChart from './LineChart'

export const LineChartResult = ({ data, status, theme, refetch }: { data: IChartData<IRevenueExpense>, status: QueryStatus, theme: Theme, refetch?: () => void }) => {
    switch (status) {
        case 'success':
            return (
                <LineChart
                    data={data}
                    options={{
                        maintainAspectRatio: false,
                        scales: {
                            x: {
                                grid: {
                                    display: false
                                }
                            },
                            y: {
                                grid: {
                                    display: false
                                }
                            }
                        },
                        plugins: {
                            tooltip: '',
                            datalabels: {
                                display: false
                            },
                            annotation: {
                                annotations: data?.datasets[0]?.data?.some(e => e > 0)
                                    ? {}
                                    : {
                                            label1: {
                                                type: 'label',
                                                content: ['No data available for the selected time period'],
                                                position: 'center',
                                                color: theme.palette.text.secondary
                                            }
                                        }
                            }
                        }
                    }}
                />
            )

        case 'loading':
            return (
                <LineChart
                    isLoading={true}
                    data={{
                        datasets: [],
                        labels: []
                    }}
                />
            )
        case 'error':
            return (
                <Stack spacing={2} sx={{ justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                    <Typography>
                        There was an error during the data fetching
                    </Typography>
                    <Button variant='contained' color='error' onClick={() => refetch?.()}>
                        Retry
                    </Button>
                </Stack>
            )
    }
}
